<template>
	<v-dialog
		v-model="showError"
		width="500"
		persistent
		>
		<v-card>
			<v-card-title class="error font-weight-black white--text" dark>
				{{errorTitle}}
			</v-card-title>
			<v-card-text class="mt-5">
				{{errorMessage}}
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn 
					color="grey darken-1"
					outlined 
					@click="dismiss"
					>
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	computed: {
		errorDebugInfo() {
			return this.$store.state.error.debugInfo;
		},
		errorMessage() {
			return this.$store.state.error.message;
		},
		errorTitle() {
			return this.$store.state.error.title;
		},
		showError() {
			return this.$store.state.error.message;
		}
	},
	methods: {
		dismiss() {
			this.$store.commit("error/clearError");
		}
	}
}
</script>